import React from "react";

interface NoDataProps {
  icon: React.ReactNode;
  title: string;
  className?: string;
}

const NoData: React.FC<NoDataProps> = ({ icon, title, className }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 h-full col-span-2 ${className}`}
    >
      <div className="bg-gray-200 rounded-full p-3.5 text-gray-500 w-12 h-12 flex items-center justify-center">
        {icon}
      </div>
      <p className="text-sm text-gray-500">{title}</p>
    </div>
  );
};

export default NoData;
